<div *ngIf="type; else notAvailableTemplate">
  <div class="uli-type" [ngClass]="{ 'highlight-outbound': highlightOutbounds && type === uliActivityType.Outbound }">
    <ui-svg-icon [name]="type | lowercase" [matTooltip]="isLabelHidden ? (type | titlecase) : null"></ui-svg-icon>
    <span *ngIf="!isLabelHidden">{{ type | titlecase }}</span>
  </div>
</div>

<ng-template #notAvailableTemplate>
  <span>{{ 'common.field.type' | translate }}: {{ notAvailable }}</span>
</ng-template>
